<div class="container-fluid page">
    <div class="row justify-content-center">
      <div class="col-md-9">
        <div *ngIf="tabType.includes('Details')">
            <!-- <div class="card shadow" style="height: 500px; overflow-y: auto;">
                <div class="card-body d-flex flex-column">
                  <div class="flex-grow-1 mb-2">
                    <strong>Code:</strong> <span class="content">{{detailObj['di_tech_nm']}}</span>
                  </div>
                  <div class="flex-grow-1 mb-2">
                    <strong>Name:</strong><span class="content">{{detailObj['di_bus_nm']}}</span> 
                  </div>
                  <div class="flex-grow-1 mb-2">
                    <strong>Description:</strong> <span class="content">{{detailObj['di_desc']}}</span>
                  </div>
                  <div class="flex-grow-1 mb-2">
                    <strong>Status:</strong><span class="content">Active</span>
                  </div>
                  <div class="flex-grow-1 mb-2">
                    <strong>Status:</strong><span class="content">{{detailObj['di_status_cd']}}</span>
                  </div>
                 
                    <div class="flex-grow-1 mb-2">
                      <strong>Status:</strong> Active
                    </div>
                </div>
              </div> -->
        </div>
       
      </div>
    </div>
  </div>
  